import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  //登录页
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/login.vue'),
  },
  //中转页
  {
    path: '/transfer',
    name: 'transfer',
    component: () => import('../views/Transfer.vue'),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/attendClass/demo2.vue'),
  },
  //老师端
  {
    path: '/teacher',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: '/teacher/teachPlan',
        name: 'teachPlan',
        component: () => import('../views/teacher/teachPlan.vue'),
      },
      {
        path: '/teacher/coursewareLibrary',
        name: 'coursewareLibrary',
        component: () => import('../views/teacher/coursewareLibrary.vue'),
      },
      {
        path: '/teacher/pubTask/:aptId',
        name: 'pubTask',
        component: () => import('../views/teacher/pubTask.vue'),
      },
      {
        path: '/teacher/taskList/:aptId',
        name: 'taskList',
        component: () => import('../views/teacher/taskList.vue'),
      },
      {
        path: '/teacher/reviewHomework/:aptId',
        name: 'reviewHomework',
        component: () => import('../views/teacher/reviewHomework.vue'),
      }
    ]
  },
  //学生端
  {
    path: '/student',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: '/student/studyPlan',
        name: 'studyPlan',
        component: () => import('../views/student/studyPlan.vue'),
      },
      {
        path: '/student/appointmentClass',
        name: 'appointmentClass',
        component: () => import('../views/student/appointmentClass.vue'),
      }, 
     
      {
        path: '/student/buyClass',
        name: 'buyClass',
        component: () => import('../views/student/buyClass.vue'),
      },
      {
        path: '/student/studentOrder',
        name: 'studentOrder',
        component: () => import('../views/student/studentOrder.vue'),
      },
      {
        path: '/student/learningReport',
        name: 'learningReport',
        component: () => import('../views/student/learningReport.vue'),
      },
      {
        path: '/student/studentNotifica',
        name: 'studentNotifica',
        component: () => import('../views/student/studentNotifica.vue'),
      }

    ]
  },
  //上课
  {
    path: '/attendClass',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: '',
        name: 'attendClass',
        component: () => import('../views/attendClass/room.vue'),
      },

    ]
  },
  //H5视频白板直播
  {
    path: '/h5Live',
    component: () => import('../views/h5Live/h5Live.vue'),
  },
  //H5视频直播
  {
    path: '/h5VideoLive',
    component: () => import('../views/h5Live/h5VideoLive.vue'),
  },
  // h5分享页
  {
    path: '/h5Share',
    component: () => import('../views/h5Share/index.vue'),
  },
  // h5-app下载页
  {
    path: '/h5Share/appDownload',
    component: () => import('../views/h5Share/appDownload.vue'),
  },
  // h5-app-AI 
  {
    path: '/h5AI',
    component: () => import('../views/h5AI/index.vue'),
  },
  // h5-app-AI 
  {
    path: '/h5CheckAI',
    component: () => import('../views/h5AI/checkAI.vue'),
  },
  // h5-app-AI 
  {
    path: '/h5Consult',
    component: () => import('../views/h5AI/consult.vue'),
  },
  {
    path:'/androidPrivacy/agressment',
    component: () => import('../views/androidPrivacy/agressment.vue'),
  },
  {
    path:'/androidPrivacy/privacy',
    component: () => import('../views/androidPrivacy/privacy.vue'),
  },
  //三角测评
  {
    path: '/h5TriangleIndex',
    component: () => import('../views/h5Triangle/h5TriangleIndex.vue'),
  },
  {
    // path: '/h5Triangle',
    // component: () => import('../views/h5Triangle/h5Triangle.vue'),
    path: '/h5Triangle',
    name: 'H5Triangle',
    component: () => import('../views/h5Triangle/h5Triangle.vue'),
  },
  // 加载报告
  {
    path: '/loadingReport',
    component: () => import('../views/h5Triangle/loadingReport.vue'),
  },
  // 解锁报告
  {
    path: '/report',
    component: () => import('../views/h5Triangle/report.vue'),
  },
  // 报告列表
  {
    path: '/reportList',
    name: 'ReportList',
    component: () => import('../views/h5Triangle/reportList.vue'),
    meta: { keepAlive: true } // 启用缓存
  },
  // 首次解锁报告
  {
    path: '/firstPayResult',
    component: () => import('../views/h5Triangle/firstPayResult.vue'),
  },
  // 解锁报告
  {
    path: '/payReportResult',
    component: () => import('../views/h5Triangle/payReportResult.vue'),
  },
  // 个人中心
  {
    path: '/user',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import('../views/personalCenter.vue'),
      }
    ]
  },
  // 404
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('@/views/error/404.vue'),
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

// 判断是否登录
// 登录白名单
const whiteList = ['/', '/transfer']
router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  // if (!userInfo) {
  //   console.log('没有登录');
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     next();
  //   } else {
  //     next('/');
  //   }
  // }
  next();
});

export default router;
